import React from "react"
import {
  ToggleWrapper,
  ToggleLeftButton,
  ToggleRightButton,
} from "./toggleButtonStyles"

const ToggleButton = React.memo(({ leftToggle, rightToggle, disabled }) => (
  <ToggleWrapper>
    <ToggleLeftButton
      selected={leftToggle.selected}
      onClick={() => !disabled && leftToggle.onToggle && leftToggle.onToggle()}
    >
      {leftToggle.label}
    </ToggleLeftButton>
    <ToggleRightButton
      selected={rightToggle.selected}
      onClick={() =>
        !disabled && rightToggle.onToggle && rightToggle.onToggle()
      }
    >
      {rightToggle.label}
    </ToggleRightButton>
  </ToggleWrapper>
))

export default ToggleButton
